import { localizeAreaLabel } from 'utils/helpers/units';

import { WIDGET_TYPES_LABELS } from './constants';

export const slugifyWidgetText = (value?: string): string => {
  if (!value) {
    return '';
  }
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};

export const getWidgetTypeLabel = (widgetType: number, unitSource?: any) => {
  const label = WIDGET_TYPES_LABELS[widgetType] ?? '';
  return localizeAreaLabel(label, unitSource);
};
